import { useJsonLd } from "@/hooks/useJsonLd";

const OFFICES = [
  { city: "Nairobi", country: "Kenya" },
  { city: "Dubai", country: "United Arab Emirates" },
  { city: "Cape Town", country: "South Africa" },
  { city: "Lagos", country: "Nigeria" },
];

// Organization + LegalService structured data, injected on every public page.
export const SiteStructuredData = () => {
  const origin = typeof window !== "undefined" ? window.location.origin : "";

  const data = {
    "@context": "https://schema.org",
    "@type": "LegalService",
    "@id": `${origin}/#organization`,
    name: "AMADI Legal Consultancy",
    url: origin,
    description:
      "AMADI Legal Consultancy advises founders, boards, and investors on corporate structuring, compliance, and cross-border matters across the UAE and Africa.",
    areaServed: ["United Arab Emirates", "Middle East", "Africa"],
    knowsAbout: [
      "Corporate structuring",
      "Regulatory and compliance (AML/CFT)",
      "Cross-border transactions",
      "Entity formation",
      "Investment advisory",
    ],
    email: "hello@amadi-legal.example",
    location: OFFICES.map((o) => ({
      "@type": "Place",
      name: `AMADI — ${o.city}`,
      address: {
        "@type": "PostalAddress",
        addressLocality: o.city,
        addressCountry: o.country,
      },
    })),
  };

  useJsonLd("ld-organization", data);
  return null;
};
